import { useSelector } from "react-redux";
import {
  selectAnnouncementsList,
  selectAnnouncementsListLoading,
} from "Redux/Announcements/slice";
import { categoryTones } from "./constants";
import { Category964Enum } from "Shared/Types/fleetmanagementapi";

export const useAnnouncements = () => {
  const loading = useSelector(selectAnnouncementsListLoading);
  const announcements = useSelector(selectAnnouncementsList);
  const getCategoryTone = (category: Category964Enum | undefined) =>
    (category && categoryTones[category]) || "neutral";

  return { loading, announcements, getCategoryTone };
};
